import React from 'react'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { PageLayout } from '@components/common/PageLayout'
import { DashboardBackButton } from '@components/utils'
import { ButtonClean, HeadContent, Skeleton } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { ConnectBar } from '../../components/ConnectBar/ConnectBar'
import * as S from './AppsIntegrationUnified.styled'
import type { AppsIntegrationUnifiedViewProps } from './types'

export const AppsIntegrationUnifiedView = ({
  connectBar,
  name,
  longDescription,
  helpCenterUrl,
  children,
}: AppsIntegrationUnifiedViewProps) => (
  <>
    <HeadContent title={name} />
    <PageLayout size="tiny">
      <Dashboard.Section
        name={name}
        title={
          <>
            {longDescription}{' '}
            <ButtonClean label="Learn More" href={helpCenterUrl} target="_blank" />.
          </>
        }
        topContent={<DashboardBackButton label="Apps" to={routing.apps.self} />}
      >
        <S.Container>
          {connectBar ? (
            <ConnectBar {...connectBar} />
          ) : (
            <Skeleton>
              <Skeleton.Shape height={64} />
            </Skeleton>
          )}
          {children}
        </S.Container>
      </Dashboard.Section>
    </PageLayout>
  </>
)
